var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { createUseStyles } from 'react-jss';
import Shortcut from '../Shortcut/Shortcut';
import { Grid, GridItem } from '@patternfly/react-core';
const useStyles = createUseStyles({
    shortcutGridItem: {
        textAlign: 'right',
        marginRight: 'var(--pf-t--global--spacer--md)'
    }
});
const ShortcutGrid = (_a) => {
    var { shortcuts, gridItemProps, ouiaId = 'ShortcutGrid' } = _a, props = __rest(_a, ["shortcuts", "gridItemProps", "ouiaId"]);
    const classes = useStyles();
    return ((_jsx(Grid, Object.assign({ span: 6, hasGutter: true, "data-ouia-component-id": ouiaId }, props, { children: shortcuts.map((shortcut, index) => {
            const { description } = shortcut, props = __rest(shortcut, ["description"]);
            return ((_jsxs(Fragment, { children: [_jsx(GridItem, Object.assign({ className: classes.shortcutGridItem, "data-ouia-component-id": `${ouiaId}-item-${index}` }, gridItemProps, { children: _jsx(Shortcut, Object.assign({}, props)) })), _jsx(GridItem, { "data-ouia-component-id": `${ouiaId}-item-description-${index}`, children: description })] }, index)));
        }) }), "grid")));
};
export default ShortcutGrid;
